module.exports = __webpack_public_path__ + "img/trawenagh-small.649411aa.jpg";